import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import Thumbnail from 'components/Thumbnail';

import EntityPropTypes from 'propTypes/entities';

import styles from './styles.module.scss';

const VirtualTourCard = ({ entity, className, onFocus }) => {
	const { title, thumbnailFile, url, federalSubject } = entity;

	return (
		<div className={cx(styles.card, className)}>
			<a href={url} className={styles.link} onFocus={onFocus}>
				<div className={styles.thumbnail}>
					<Thumbnail
						file={thumbnailFile}
						params={{ width: 400, height: 400 }}
						keepRatio
					/>
					<div className={styles.figure}>
						<Icon icon="virtual-tour" className={styles.icon} />
					</div>
				</div>
				<div className={styles.title}>{title}</div>
			</a>
			{federalSubject && (
				<div className={styles.place}>{federalSubject.title}</div>
			)}
		</div>
	);
};

VirtualTourCard.propTypes = {
	entity: EntityPropTypes.virtualTours.isRequired,
	className: PropTypes.string,
	onFocus: PropTypes.func
};

export default VirtualTourCard;
